"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require("@angular/core");
var SidebarComponent = (function () {
    function SidebarComponent() {
        this.fullHeight = false;
    }
    return SidebarComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], SidebarComponent.prototype, "open", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], SidebarComponent.prototype, "fullHeight", void 0);
SidebarComponent = __decorate([
    core_1.Component({
        selector: 'sidebar',
        template: "\n      <aside class=\"sidebar c-overflow\" id=\"sidebar\" style=\"overflow: visible\" [ngClass]=\"{ 'toggled': open, 'full-height': fullHeight }\"><div id=\"mCSB_1\" tabindex=\"0\" style=\"height: 100%\"><div style=\"position: relative; top: 0px; left: 0px; width: 100%; height: 100%; overflow: auto\" dir=\"ltr\"><ng-content></ng-content></div></div></aside>\n    ",
    }),
    __metadata("design:paramtypes", [])
], SidebarComponent);
exports.SidebarComponent = SidebarComponent;



//////////////////
// WEBPACK FOOTER
// ./~/ng2-material-components/user-interface/sidebar/sidebar.component.js
// module id = 117
// module chunks = 0